import PropTypes from "prop-types";
import { forwardRef, memo } from "react";
import { FormControlLabel, Checkbox, Typography, Box } from "@mui/material";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const MuiCheckbox = forwardRef(function MuiCheckbox(
  {
    className,
    color,
    label,
    onChange,
    error,
    name,
    size,
    icon,
    checkedIcon,
    checked,
    defaultValue,
    isErrorVisible,
    disabled,
    fontSize,
    sx,
    labelPlacement,
    isSquareBox,
    isHidden,
    touched,
    ...restProps
  },
  ref
) {
  const handleChange = (e) => {
    onChange(e);
  };
  return (
    <Box sx={{ display: isHidden ? "none" : "block" }}>
      <FormControlLabel
        control={
          <Checkbox
            icon={
              isSquareBox ? (
                <CheckBoxOutlineBlankIcon
                  sx={{
                    fontSize: "1rem",
                    color: "color.aigColor15",
                    opacity: disabled ? "0.6" : "1",
                    ...fontSize,
                  }}
                />
              ) : (
                <CircleOutlinedIcon
                  sx={{
                    fontSize: "1rem",
                    color: "color.aigColor15",
                    opacity: disabled ? "0.6" : "1",
                    ...fontSize,
                  }}
                />
              )
            }
            checkedIcon={
              isSquareBox ? (
                <CheckBoxIcon
                  sx={{
                    color: "color.aigColor17",
                    fontSize: "1rem",
                    opacity: disabled ? "0.6" : "1",
                    ...fontSize,
                  }}
                />
              ) : (
                <CheckCircleIcon
                  sx={{
                    color: "color.aigColor17",
                    fontSize: "1rem",
                    opacity: disabled ? "0.6" : "1",
                    ...fontSize,
                  }}
                />
              )
            }
            inputRef={ref}
            checked={checked || false}
            defaultValue={defaultValue}
            onChange={handleChange}
            name={name}
            classes={className}
            size={""}
            color={"default"}
            disabled={disabled}
            {...restProps}
          />
        }
        labelPlacement={labelPlacement}
        sx={{ ...sx }}
        label={
          <Typography
            variant="aigBodyM"
            sx={{ fontWeight: "fontWeightMedium" }}
          >
            {label}
          </Typography>
        }
      />
      <br />
      {isErrorVisible && error ? (
        <span className="inputErrorText font-14 font-sm-12">
          {error.message}
        </span>
      ) : null}
    </Box>
  );
});

MuiCheckbox.propTypes = {
  checked: PropTypes.bool,
  checkedIcon: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  defaultValue: PropTypes.oneOf(["string", "bool"]),
  disabled: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.any,
  }),
  fontSize: PropTypes.object,
  icon: PropTypes.node,
  isErrorVisible: PropTypes.bool,
  isSquareBox: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelPlacement: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(["medium", "small"]),
  sx: PropTypes.object,
  touched: PropTypes.bool,
  isHidden: PropTypes.bool,
};

MuiCheckbox.defaultProps = {
  color: "primary",
  size: "medium",
  isErrorVisible: true,
  disabled: false,
  isHidden: false,
};

export default memo(MuiCheckbox);
